import { PRODUCT_TERMS } from '../../../constants/productTerminology';

const looksLikeRawId = (value) => {
  const text = String(value || '').trim();
  if (!text) return false;
  return /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(text)
    || /^[0-9a-f]{20,}$/i.test(text);
};

const firstReadable = (...values) => values
  .map((value) => {
    if (!value) return '';
    if (typeof value === 'string') return value.trim();
    if (typeof value === 'object') {
      return String(value.name || value.fullName || value.displayName || value.email || '').trim();
    }
    return '';
  })
  .find((value) => value && !looksLikeRawId(value));

export function normalizeDiscoveryResultToContext(result = {}) {
  const item = result.context || result.raw || result;
  const name = result.name || item.name || item.title || PRODUCT_TERMS.knowledge.untitled;
  const authorName = firstReadable(
    item.author,
    result.author,
    item.userName,
    result.userName,
    item.owner,
    result.owner,
    item.ownerName,
    result.ownerName,
    item.createdBy,
    result.createdBy,
    item.createdByName,
    result.createdByName,
    item.creatorName,
    result.creatorName,
    item.user,
    result.user,
    item.userEmail,
    result.userEmail
  );
  const authorEmail = item.author?.email || result.author?.email || item.userEmail || result.userEmail;
  const authorId = item.author?.id || result.author?.id || item.userId || result.userId;
  return {
    ...item,
    id: item.id || result.id,
    name,
    title: name,
    description: result.description || item.description || '',
    hasAccess: item.hasAccess !== false,
    author: item.author || result.author || (authorName
      ? {
        name: authorName,
        id: authorId,
        email: authorEmail,
      }
      : (authorId ? { id: authorId, email: authorEmail } : undefined)),
    userName: authorName || (looksLikeRawId(item.userName) ? undefined : item.userName) || (looksLikeRawId(result.userName) ? undefined : result.userName),
    userEmail: authorEmail,
    userId: authorId,
    category: item.category || result.category,
    collection: item.collection,
    collectionId: item.collectionId,
    collectionName: item.collectionName,
    stats: item.stats,
    likes: item.likes,
    favorites: item.favorites,
    usage: item.usage,
    createdAt: item.createdAt,
  };
}
